import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0d43abc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-info" }
const _hoisted_2 = { class: "chat-info-inner" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  key: 0,
  class: "ongoingCall"
}
const _hoisted_5 = {
  key: 1,
  class: "members"
}
const _hoisted_6 = { class: "chat-handlers" }
const _hoisted_7 = {
  key: 0,
  class: "call"
}
const _hoisted_8 = { class: "settings" }

import TopBarDeletingMessagesButtons from "@/components/buttons/TopBarDeletingMessagesButtons.vue";
import MobileNavigationBackButton from "@/components/buttons/MobileNavigationBackButton.vue";
import ProfileImage from "@/components/images/ProfileImage.vue";
import OneToOneChatOptionsCard from "@/components/cards/OneToOneChatOptionsCard.vue";
import GroupChatOptionsCard from "@/components/cards/GroupChatOptionsCard.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import { useStore } from "vuex";
import { GetterTypes, MutationTypes } from "@/store";
import { Chat, ChatTypes } from "@/store/chats/types";
import {
  AppEnvironment,
  AppEnvironmentEnum,
  Layout,
  LayoutTypes,
  PopupTypes,
} from "@/store/app/state";

import { getVersionNumber } from "@/utils/app";
import { useComputedValue } from "@/composables/useComputedValue";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { getFullChatName } from "@/utils/chat";
import { startCallBeAsync } from "@/services/chatApi";
import {
  BridgeMessageAppDetailsResponseObject,
  CallType,
} from "@/types/webview";
import { config } from "@/config";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatTopBar',
  setup(__props) {

const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const chat = useComputedValue<Chat>(GetterTypes.GET_SELECTED_CHAT);
const layout = useComputedValue<Layout>(GetterTypes.GET_LAYOUT);
const deletingMessages = useComputedValue<string[] | null>(
  GetterTypes.GET_SELECTED_MESSAGE_IDS,
);
const appDetails = useComputedValue<BridgeMessageAppDetailsResponseObject>(
  GetterTypes.GET_APP_DETAILS,
);
const chatId = computed(() => chat.value.id);
const { commit } = useStore();
const router = useRouter();
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const messageReactionId = useComputedValue<string | null>(
  GetterTypes.GET_MESSAGE_REACTION_ID,
);
const isBlurred = computed(() => !!messageReactionId.value);
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isMobileApp = computed(() => environment.value.isMobileApp);

const showEditGroup = () => {
  if ((chat.value && chat.value.type !== ChatTypes.GROUP_CHAT) || isMobileApp)
    return;

  commit(MutationTypes.SHOW_POPUP, {
    popupType: PopupTypes.EDIT_GROUP,
  });
};

const openChatSettings = () => {
  if (isMobileApp.value) {
    router.push(`/settings/chat/${chat.value.id}`);
  }
};

const appliedChatName = computed<string>(() => {
  return getFullChatName(chat.value);
});

const getStartCallHandler = (callType: CallType) => async () => {
  await startCallBeAsync({
    chatId: chatId.value,
    userId: authId.value,
    callType,
    isDesktop: isDesktopCall.value,
  });
};

const startVideoCall = getStartCallHandler(CallType.Video);
const startAudioCall = getStartCallHandler(CallType.Audio);
const joinCall = getStartCallHandler(chat.value.pendingCallType);
const isDesktopCall = computed(
  () =>
    environment.value.operatingSystem === AppEnvironmentEnum.Web &&
    layoutType.value === LayoutTypes.DESKTOP,
);

const isCallFunctionalityAvailable = computed<boolean>(() => {
  if (isDesktopCall.value) {
    return true;
  }
  return (
    getVersionNumber(appDetails.value.currentAppVersion) >=
    getVersionNumber(config.constants.CALLS_AVAILABLE_APP_VERSION)
  );
});
const hasOngoingCall = computed<boolean>(
  () => !!chat.value.activeCall && isCallFunctionalityAvailable.value,
);
const isGroupChatMembersNameShown = computed<boolean>(
  () =>
    !hasOngoingCall.value &&
    chat.value.type === ChatTypes.GROUP_CHAT &&
    chat.value.hasName,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-top-bar", {
      webview: isMobileApp.value,
      isBlurred: isBlurred.value,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MobileNavigationBackButton),
      _createElementVNode("div", _hoisted_2, [
        (!(_unref(deletingMessages) && _unref(layout).width < 1200))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "picture-wrapper",
              onClick: showEditGroup
            }, [
              _createVNode(ProfileImage, {
                id: _unref(chat).id,
                image: _unref(chat).picture,
                size: _unref(layout).type === _unref(LayoutTypes).MOBILE ? 36 : 48,
                "disable-redirect": isMobileApp.value,
                onClick: _withModifiers(openChatSettings, ["stop"])
              }, null, 8, ["id", "image", "size", "disable-redirect"])
            ]))
          : _createCommentVNode("", true),
        (!(_unref(deletingMessages) && _unref(layout).width < 1200))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "chat-name-wrapper",
              onClick: showEditGroup
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(appliedChatName.value), 1),
              (hasOngoingCall.value || isGroupChatMembersNameShown.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (hasOngoingCall.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("call.status.ongoing")), 1))
                      : _createCommentVNode("", true),
                    (isGroupChatMembersNameShown.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(chat).nameFromMembers), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(deletingMessages))
      ? (_openBlock(), _createBlock(TopBarDeletingMessagesButtons, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (hasOngoingCall.value)
        ? (_openBlock(), _createBlock(GenericButton, {
            key: 0,
            class: "joinButton",
            onClick: _unref(joinCall)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("call.join")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (isCallFunctionalityAvailable.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(Icon, {
                    icon: _unref(IconType).CAM,
                    alt: "cam",
                    class: "icon",
                    onClick: _unref(startVideoCall)
                  }, null, 8, ["icon", "onClick"]),
                  _createVNode(Icon, {
                    icon: _unref(IconType).PHONE,
                    alt: "phone",
                    class: "icon",
                    onClick: _unref(startAudioCall)
                  }, null, 8, ["icon", "onClick"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              (!isMobileApp.value && _unref(chat).type === _unref(ChatTypes).ONE_TO_ONE_CHAT)
                ? (_openBlock(), _createBlock(OneToOneChatOptionsCard, { key: 0 }))
                : _createCommentVNode("", true),
              (!isMobileApp.value && _unref(chat).type === _unref(ChatTypes).GROUP_CHAT)
                ? (_openBlock(), _createBlock(GroupChatOptionsCard, { key: 1 }))
                : _createCommentVNode("", true)
            ])
          ], 64))
    ])
  ], 2))
}
}

})